import { jsxs, jsx } from "react/jsx-runtime";
import FlashBrandIcon from "../../icons/FlashBrandIcon/FlashBrandIcon.js";
import "../../../constants.js";
function FlashButtonContentBrandIcon(props) {
  const { brand, children } = props;
  return /* @__PURE__ */ jsxs("span", { className: "d-flex gap-2 align-items-center py-flash-025 my-nflash-050", children: [
    /* @__PURE__ */ jsx("span", { className: "mt-nflash-050", children: /* @__PURE__ */ jsx(FlashBrandIcon, { ...brand }) }),
    children
  ] });
}
export {
  FlashButtonContentBrandIcon as default
};
//# sourceMappingURL=FlashButtonContentBrandIcon.js.map
